export default "__VITE_ASSET__D5F1EKlX__"